import { SnackBarService } from './snack-bar.service';

export const SERVICES = [SnackBarService];

export { SnackBarService } from './snack-bar.service';
